/* eslint-disable no-prototype-builtins */
/* eslint-disable no-undef */
/* eslint-disable no-restricted-syntax */
import { Form, Input, Select } from 'antd';
// import TimezoneSelect from 'react-timezone-select';
// import timezones from './timezones.json';
import timezones from './timezone';

// const useOptions = () => {
//   const options = [];
//   for (const key in timezones) {
//     if (timezones.hasOwnProperty(key)) {
//       const ele = timezones[key];
//       options.push({
//         value: ele,
//         label: ele,
//       });
//     }
//   }
//   return options;
// };

export default function CompanyInfo() {
  // const [selectedTimezone, setSelectedTimezone] = useState(
  //   { value: Intl.DateTimeFormat()?.resolvedOptions(), label: 'dddd' },
  // );
  // console.log(selectedTimezone);

  // const options = useOptions();
  return (
    <div>
      <Form.Item label="Legal business name" name="legalBusinessName">
        <Input />
      </Form.Item>
      <Form.Item label="Website" name="website">
        <Input addonBefore="https://" />
      </Form.Item>
      <Form.Item label="Time zone" name="timeZone">
        <Select options={timezones} />
      </Form.Item>
    </div>
  );
}
